import React from 'react';
import { SlideContent, SlideType } from '../../types';
import { StatementSlide } from './StatementSlide';
import { TwoColumnSlide } from './TwoColumnSlide';
import { ComparisonTableSlide } from './ComparisonTableSlide';
import { QuoteSlide } from './QuoteSlide';
import { ClosingEmotionalSlide } from './ClosingEmotionalSlide';
// TODO: Import remaining slide components when created

interface SlideRendererProps {
  slide: SlideContent;
  isActive?: boolean;
}

export const SlideRenderer: React.FC<SlideRendererProps> = ({ slide, isActive = true }) => {
  if (!isActive) return null;

  const renderSlide = () => {
    switch (slide.type) {
      case 'statement':
        return (
          <StatementSlide
            content={slide.content}
            speakerNotes={slide.speakerNotes}
          />
        );
      
      case 'two-column':
        return (
          <TwoColumnSlide
            content={slide.content}
            title={slide.title}
            speakerNotes={slide.speakerNotes}
          />
        );
      
      case 'comparison-table':
        return (
          <ComparisonTableSlide
            content={slide.content}
            title={slide.title}
            speakerNotes={slide.speakerNotes}
          />
        );
      
      case 'quote':
        return (
          <QuoteSlide
            content={slide.content}
            speakerNotes={slide.speakerNotes}
          />
        );
      
      case 'closing-emotional':
        return (
          <ClosingEmotionalSlide
            content={slide.content}
            speakerNotes={slide.speakerNotes}
          />
        );
      
      // TODO: Add remaining slide types
      case 'architecture':
      case 'timeline':
      case 'device-showcase':
        return (
          <div className="slide-container">
            <div className="slide-content flex items-center justify-center">
              <div className="text-center">
                <h2 className="text-3xl font-light text-warm-gray mb-4">
                  {slide.type.charAt(0).toUpperCase() + slide.type.slice(1).replace('-', ' ')} Slide
                </h2>
                <p className="text-warm-gray">Coming soon...</p>
              </div>
            </div>
          </div>
        );
      
      default:
        return (
          <div className="slide-container">
            <div className="slide-content flex items-center justify-center">
              <div className="text-center">
                <h2 className="text-3xl font-light text-warm-gray mb-4">Unknown Slide Type</h2>
                <p className="text-warm-gray">{slide.type}</p>
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="w-full h-full">
      {renderSlide()}
    </div>
  );
};